<template>
  <div class="app-container">
    <div class="filter-container flex">
      <el-button type="primary" @click="handleCreate">新增</el-button>
      <div style="display: flex; justify-content: center;">
        <div>
          <el-input v-model="listQuery.title" placeholder="标题" clearable />
        </div>
        <div>
          <el-select v-model="listQuery.state" placeholder="状态" style="width: 200px; margin:0 10px;" type="primary"
            clearable>
            <el-option label="正常" :value="1" />
            <el-option label="已下架" :value="0" />
          </el-select>
        </div>
        <el-button type="primary" @click="handleFilter">搜索</el-button>
      </div>
    </div>


    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="封面" width="150">
        <template slot-scope="scope">
          <el-image class="image-url" :src="scope.row.cover_img" :preview-src-list="[scope.row.cover_img]" />
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="60" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.state === 0" type="warning">已下架</el-tag>
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="权重" min-width="50" align="center" prop="sort" />
      <el-table-column align="center" prop="created_at" label="创建时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.state === 1" type="warning" size="mini"
            @click="handleForbid(scope.row.id, '下架')">下架</el-button>
          <el-button v-else size="mini" type="success" @click="handleForbid(scope.row.id, '上架')">上架</el-button>

          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>


    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="60%"
      destroy-on-close>
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="140px">

        <el-form-item label="图片(380*214倍数)" prop="cover_img">
          <upload-one v-model="form.cover_img" width="100%" height="300px"></upload-one>
        </el-form-item>

        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="发布时间:" prop="release_at">
          <el-date-picker :editable="false" v-model="form.release_at" type="datetime" value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm" placeholder="选择日期" :clearable="false" />
        </el-form-item>

        <el-form-item label="详情" prop="content">
          <tinymce ref="tinymce" style="width:100%;" :height="300" v-model="form.content" :value="form.content" />
        </el-form-item>

        <el-form-item label="权重" prop="sort">
          <el-input-number v-model="form.sort" :min="1" :max="9999"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { news } from "@/api/operation"
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import Tinymce from '@/components/Tinymce'


export default {

  components: {
    "img-crop-upload": imgCropUpload, Tinymce,
    uploadList
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        title: '',
        state: null
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      form: {
        id: "",
        title: "",
        content: "",
        cover_img: "",
        release_at: '',
        sort: 1,
      },
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        cover_img: [{ required: true, message: "图片不能为空", trigger: "blur" }],
        content: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        release_at: [{ required: true, message: "发布时间不能为空", trigger: "blur" }],
        sort: [{ required: true, message: "权重不能为空", trigger: "blur" }]
      },
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      news.list(this.listQuery).then(({ data }) => {
        let formatData = data.data.sort((v1, v2) => v2.sort - v1.sort)

        this.list = formatData;
        this.total = data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        title: "",
        content: "",
        cover_img: "",
        release_at: '',
        sort: 1
      };
      this.btnLoading = false;
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      if (this.$refs.tinymce) this.$refs.tinymce.setContent('')
      this.$nextTick(() => {
        this.$refs['form'].clearValidate() //清除校验结果
      })
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row); // copy obj
      this.form.type = Number(this.form.type)
      console.log('编辑内容', this.form)
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      console.log(this.form, this.form.imgArray);
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/operation/news/add", // category_id:{1.首页轮播图}
            method: "post",
            data: this.form
          })
            .then(() => {
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/operation/news/state",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => { });
    },

    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/operation/news/del",
            method: "post",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

  }
};
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.upload-one-component .upload-one-component-image {
  width: auto;
  height: 200px;
}

.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
</style>
